import { TextField } from "@mui/material";
import { HatRetroControlConfigurationWithTypeTag } from "hat-common";
import { useCallback } from "react";
import styled from "styled-components";
import {
  FieldAndLabelRow,
  SpacedVerticalStack,
} from "../../../common/CommonStyled";
import "../../../common/EditButton.css";
import { ControlPropertiesEditorProps } from "./ControlEditingSupport";

export function ControlSettingsEditorLedStrip({
  controlConfiguration,
  onControlConfigurationChanged,
}: ControlPropertiesEditorProps<"rgbw_mono">) {
  const updateDeviceSettings = useCallback(
    (
      settings: Partial<
        HatRetroControlConfigurationWithTypeTag<"rgbw_mono">["otherSettings"]
      >
    ) => {
      const newControl: HatRetroControlConfigurationWithTypeTag<"rgbw_mono"> = {
        ...controlConfiguration,
        otherSettings: {
          ...controlConfiguration.otherSettings,
          ...settings,
        },
      };

      onControlConfigurationChanged(newControl);
    },
    [controlConfiguration, onControlConfigurationChanged]
  );

  const currentSettings = controlConfiguration.otherSettings;

  return (
    <SpacedVerticalStack>
      <FieldAndLabelRow>
        <FixedWidthLabel>Strip Type:</FixedWidthLabel>
        <TextField
          type="number"
          size="small"
          inputProps={{ min: 0, max: 5 }}
          value={currentSettings.ledType}
          onChange={(event) =>
            updateDeviceSettings({ ledType: parseInt(event.target.value) })
          }
        />
      </FieldAndLabelRow>
      <FieldAndLabelRow>
        <FixedWidthLabel>Number of LEDs:</FixedWidthLabel>
        <TextField
          type="number"
          size="small"
          inputProps={{ min: 0, max: 255 }}
          value={currentSettings.stripSize}
          onChange={(event) =>
            updateDeviceSettings({ stripSize: parseInt(event.target.value) })
          }
        />
      </FieldAndLabelRow>
    </SpacedVerticalStack>
  );
}

const FixedWidthLabel = styled.div`
  width: 14rem;
`;
